var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1854 12.3456C23.1854 12.3456 22.9759 12.8168 22.5487 13.4953C22.5487 13.4953 21.707 14.8322 20.5928 15.9463C20.5928 15.9463 16.9982 19.541 12 19.541C12 19.541 7.00184 19.541 3.40717 15.9463C3.40717 15.9463 2.29298 14.8322 1.45126 13.4953C1.45126 13.4953 1.02406 12.8168 0.814641 12.3456C0.728453 12.1517 0.728453 11.9303 0.814641 11.7364C0.814641 11.7364 1.02406 11.2652 1.45126 10.5867C1.45126 10.5867 2.29298 9.24988 3.40717 8.13569C3.40717 8.13569 7.00184 4.54102 12 4.54102C12 4.54102 16.9981 4.54102 20.5928 8.13569C20.5928 8.13569 21.707 9.24987 22.5487 10.5867C22.5487 10.5867 22.9759 11.2652 23.1854 11.7364C23.2715 11.9303 23.2715 12.1517 23.1854 12.3456ZM21.2794 12.6961C21.2794 12.6961 21.5125 12.3259 21.6644 12.041C21.6644 12.041 21.5125 11.7561 21.2794 11.3859C21.2794 11.3859 20.5273 10.1915 19.5322 9.19635C19.5322 9.19635 16.3768 6.04102 12 6.04102C12 6.04102 7.62316 6.04102 4.46783 9.19635C4.46783 9.19635 3.47265 10.1915 2.72061 11.3859C2.72061 11.3859 2.48753 11.7561 2.33558 12.041C2.33558 12.041 2.48753 12.3259 2.72061 12.6961C2.72061 12.6961 3.47265 13.8905 4.46783 14.8857C4.46783 14.8857 7.62316 18.041 12 18.041C12 18.041 16.3768 18.041 19.5322 14.8857C19.5322 14.8857 20.5273 13.8905 21.2794 12.6961Z",
    fill: "#AC98F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.54102C12 7.54102 13.864 7.54102 15.182 8.85904C15.182 8.85904 16.5 10.1771 16.5 12.041C16.5 12.041 16.5 13.905 15.182 15.223C15.182 15.223 13.864 16.541 12 16.541C12 16.541 10.136 16.541 8.81802 15.223C8.81802 15.223 7.5 13.905 7.5 12.041C7.5 12.041 7.5 10.1771 8.81802 8.85904C8.81802 8.85904 10.136 7.54102 12 7.54102ZM12 9.04102C12 9.04102 10.7574 9.04102 9.87868 9.91969C9.87868 9.91969 9 10.7984 9 12.041C9 12.041 9 13.2837 9.87868 14.1623C9.87868 14.1623 10.7574 15.041 12 15.041C12 15.041 13.2426 15.041 14.1213 14.1623C14.1213 14.1623 15 13.2837 15 12.041C15 12.041 15 10.7984 14.1213 9.91969C14.1213 9.91969 13.2426 9.04102 12 9.04102Z",
    fill: "#AC98F6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.37a735eeaa12b74ef3f35d059861426c.svg";
export { ForwardRef as ReactComponent };